import type { ReactNode } from 'react';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';

/**
 * Мелкие помощники презентации для телефона (используются только в мобильных ветках).
 */

/** `padding` полноэкранной страницы на телефоне: базовый отступ `px` + безопасные зоны iPhone
 *  (вырез сверху, «домашняя» полоса снизу, боковые вырезы в ландшафте). */
export function safeAreaPadding(px: number): string {
  return `calc(${px}px + env(safe-area-inset-top, 0px)) calc(${px}px + env(safe-area-inset-right, 0px)) calc(${px}px + env(safe-area-inset-bottom, 0px)) calc(${px}px + env(safe-area-inset-left, 0px))`;
}

/** Высота полноэкранного блока (загрузка, ошибка, 404): на телефоне — `100dvh` (динамический
 *  вьюпорт без «прыжка» от адресной строки Safari), на десктопе — прежняя `100vh`. */
export function fullScreenMinHeight(isMobile: boolean): string {
  return isMobile ? '100dvh' : '100vh';
}

/** Значок «показать пароль» для `Input.Password` на телефоне: та же иконка, но цель касания 44×44px
 *  (поле остаётся прежней высоты — зона касания выходит за значок отрицательным отступом). */
export function touchPasswordIcon(visible: boolean): ReactNode {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 44, height: 44, margin: -12 }}>
      {visible ? <EyeOutlined /> : <EyeInvisibleOutlined />}
    </span>
  );
}
